import './index.css';
import { deferUntilNeeded } from './lib/defer-until-needed.ts';

function bootApp() {
  void import('./bootstrap.tsx');
}

if (import.meta.env.DEV || !document.getElementById('home-shell')) {
  bootApp();
} else {
  deferUntilNeeded(bootApp, 10000);
}
